var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useLanguage } from '@base/LanguageProvider';
import { useGroups, useUserGroupActions } from '@data/hooks/usersAndGroups';
import useFuseSearch from '@hooks/useFuseSearch';
import FSButton from '@components/FSButton';
import Input from '@shared/input/Input';
import SearchInput from '@shared/input/SearchInput';
import List from '@shared/List';
import Manager from '@shared/modal/Manager';
import { Color } from '@util/enums';
import React, { useState } from 'react';
import { DragDropContext, Draggable, Droppable, } from 'react-beautiful-dnd';
import { AiOutlineRobot } from 'react-icons/ai';
import { FaPlus } from 'react-icons/fa';
import { RiCloseFill, RiEdit2Line } from 'react-icons/ri';
import { getFullName, getInitials } from '@data/user/user';
import { useActionsByUserId, useUsers } from '@data/user/userActions';
import { Delete } from '@shared/icons/icons';
import { appColors } from '@styled/useTheme';
import BorderdContainer from '../BorderedContainer';
import MoreOptions from '../MoreOptions';
import DeleteUserModal from './DeleteUserModal';
import UserModal from './UserModal';
import PermissionsModal from './PermissionsModal';
import ManagerLayoutWithButton from '../ManagerLayoutWithButton';
import { useAuth } from '../../../../providers/AuthProvider';
var AVATAR_SIZE = 30;
var SEARCH_INPUT_STYLE = { margin: '15px', flexGrow: 0 };
var LIST_ITEM = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderRadius: 5,
    height: 50,
    padding: 15,
};
var AVATAR_STYLE = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: AVATAR_SIZE,
    height: AVATAR_SIZE,
    backgroundColor: '#F2F4F9',
    borderRadius: AVATAR_SIZE / 2,
    marginRight: 30,
};
var AVATAR_INITIALS_STYLE = {
    margin: 0,
    padding: 0,
    fontSize: 10,
    display: 'inline',
    textAlign: 'center',
    fontWeight: 'bold',
    color: '#6B83A0',
};
var GROUP_HEADER_STYLE = {
    height: 50,
    padding: 15,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderBottomWidth: 1,
    borderBottomStyle: 'solid',
    borderBottomColor: '#E7EAF0',
};
var USER_LIST_ITEM_STYLE = __assign({ backgroundColor: 'white', boxShadow: '0px 4px 16px rgba(107, 131, 160, 0.15)' }, LIST_ITEM);
var GROUP_LIST_ITEM_STYLE = {
    borderRadius: 5,
    height: 220,
    display: 'flex',
    flexDirection: 'column',
    border: '1px solid #E7EAF0',
};
var USER_FULLNAME_STYLE = {
    display: 'inline-block',
    fontSize: 12,
    textAlign: 'center',
    color: '#001024',
    margin: 0,
};
var FUSE_CONFIG = {
    keys: [{ name: 'title', weight: 1 }],
    threshold: 0.25,
    minMatchCharLength: 2,
    useExtendedSearch: true,
};
var ResourceType;
(function (ResourceType) {
    ResourceType["USER"] = "User";
    ResourceType["GROUP"] = "Group";
})(ResourceType || (ResourceType = {}));
function userToListItem(user, actions) {
    return __assign({ title: user.keycloakId ? getFullName(user) : user.firstName, style: null, Icon: user.keycloakId ? (React.createElement(UserAvatar, { initials: getInitials(user) })) : (React.createElement("span", { style: AVATAR_STYLE },
            React.createElement(AiOutlineRobot, { cursor: "pointer", color: appColors.neutral.w700, size: 18, stroke: "2px" }))) }, actions);
}
function groupToListItem(group) {
    return {
        id: group.id,
        title: group.name,
        style: null,
        userItems: [],
    };
}
function getUserAndGroupItems(users, groups, actionsByUserId) {
    var e_1, _a, e_2, _b, e_3, _c;
    var userItemsMap = new Map();
    try {
        for (var users_1 = __values(users), users_1_1 = users_1.next(); !users_1_1.done; users_1_1 = users_1.next()) {
            var user = users_1_1.value;
            var actions = actionsByUserId[user.id];
            userItemsMap.set(user.id, userToListItem(user, actions !== null && actions !== void 0 ? actions : { id: user.id, canDelete: false, canUpdate: false }));
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (users_1_1 && !users_1_1.done && (_a = users_1.return)) _a.call(users_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    var groupItems = [];
    try {
        for (var groups_1 = __values(groups), groups_1_1 = groups_1.next(); !groups_1_1.done; groups_1_1 = groups_1.next()) {
            var group = groups_1_1.value;
            var groupItem = groupToListItem(group);
            try {
                for (var _d = (e_3 = void 0, __values(group.userIds)), _e = _d.next(); !_e.done; _e = _d.next()) {
                    var userId = _e.value;
                    if (userItemsMap.has(userId)) {
                        groupItem.userItems.push(userItemsMap.get(userId));
                    }
                }
            }
            catch (e_3_1) { e_3 = { error: e_3_1 }; }
            finally {
                try {
                    if (_e && !_e.done && (_c = _d.return)) _c.call(_d);
                }
                finally { if (e_3) throw e_3.error; }
            }
            groupItems.push(groupItem);
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (groups_1_1 && !groups_1_1.done && (_b = groups_1.return)) _b.call(groups_1);
        }
        finally { if (e_2) throw e_2.error; }
    }
    return { userItems: Array.from(userItemsMap.values()), groupItems: groupItems };
}
function HeaderWithButton(_a) {
    var title = _a.title, _b = _a.disabled, disabled = _b === void 0 ? false : _b, buttonTitle = _a.buttonTitle, buttonClickHandler = _a.buttonClickHandler;
    return (React.createElement("div", { style: {
            marginBottom: 15,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
        } },
        React.createElement("h3", { style: { margin: 0, fontSize: 14 } }, title),
        React.createElement(FSButton, { icon: FaPlus, title: buttonTitle, onClick: buttonClickHandler })));
}
function UserAvatar(_a) {
    var initials = _a.initials;
    return (React.createElement("span", { style: AVATAR_STYLE },
        React.createElement("p", { style: AVATAR_INITIALS_STYLE }, initials)));
}
function UserContent(_a) {
    var userItem = _a.userItem;
    return (React.createElement("div", { style: { display: 'flex', alignItems: 'center' } },
        userItem.Icon,
        React.createElement("p", { style: USER_FULLNAME_STYLE }, userItem.title)));
}
function UserItem(_a) {
    var userItem = _a.userItem, index = _a.index;
    function renderDraggableItem(_a, _b) {
        var innerRef = _a.innerRef, draggableProps = _a.draggableProps, dragHandleProps = _a.dragHandleProps;
        var isDragging = _b.isDragging, isDropAnimating = _b.isDropAnimating;
        var style = !isDragging ? userItem.style : __assign(__assign({}, userItem.style), draggableProps.style);
        var item = isDropAnimating ? (React.createElement(GrouppedUserItem, { userItem: userItem, groupId: 0 })) : (React.createElement("div", __assign({ ref: innerRef }, draggableProps, dragHandleProps, { style: __assign(__assign({}, USER_LIST_ITEM_STYLE), style) }),
            React.createElement(UserContent, { userItem: userItem }),
            userItem.canDelete ? (React.createElement(Delete, { destructive: true, cursor: "pointer", onClick: function () { return Manager.renderModal(React.createElement(DeleteUserModal, { userId: userItem.id })); } })) : null));
        return item;
    }
    return (React.createElement(Draggable, { key: userItem.id, draggableId: "".concat(ResourceType.USER, ":").concat(userItem.id), index: index }, renderDraggableItem));
}
function GrouppedUserItem(_a) {
    var userItem = _a.userItem, groupId = _a.groupId;
    var removeUserFromGroup = useUserGroupActions().removeUserFromGroup;
    function removeHandler() {
        removeUserFromGroup(userItem.id, groupId);
    }
    return (React.createElement("div", { style: LIST_ITEM },
        React.createElement(UserContent, { userItem: userItem }),
        React.createElement(RiCloseFill, { cursor: "pointer", color: "#E74C3C", onClick: removeHandler })));
}
function GroupItem(_a) {
    var groupItem = _a.groupItem, index = _a.index;
    var isStub = !!groupItem.stub;
    var L = useLanguage().L;
    var _b = __read(useState(false), 2), edit = _b[0], setEdit = _b[1];
    var _c = __read(useState(false), 2), showOptions = _c[0], setShowOptions = _c[1];
    var _d = __read(useState(isStub ? '' : groupItem.title), 2), newGroupName = _d[0], setNewGroupName = _d[1];
    var _e = useUserGroupActions(), createGroup = _e.createGroup, updateGroup = _e.updateGroup, removeGroup = _e.removeGroup;
    function nameChangeHandler(e) {
        setNewGroupName(e.target.value);
    }
    function editOnHandler() {
        if (!isStub) {
            setEdit(true);
            setShowOptions(false);
        }
    }
    function editOffHandler() {
        setEdit(false);
    }
    function toggleOptions() {
        setShowOptions(function (curr) { return !curr; });
    }
    function closeOptionsHandler() {
        setShowOptions(false);
    }
    function removeHandler() {
        var _a;
        if (isStub) {
            if (edit) {
                editOffHandler();
                return;
            }
            (_a = groupItem.stub) === null || _a === void 0 ? void 0 : _a.removeStub();
        }
        else {
            removeGroup(groupItem.id);
            setShowOptions(false);
        }
    }
    function confirmHandler(e) {
        var _a, _b;
        if (e.key === 'Escape') {
            if (edit) {
                editOffHandler();
                return;
            }
            (_a = groupItem.stub) === null || _a === void 0 ? void 0 : _a.removeStub();
        }
        if (e.key === 'Enter') {
            if (edit) {
                updateGroup(groupItem.id, { name: newGroupName });
                editOffHandler();
                return;
            }
            createGroup(newGroupName);
            (_b = groupItem.stub) === null || _b === void 0 ? void 0 : _b.removeStub();
        }
    }
    function renderDroppableItem(_a) {
        var innerRef = _a.innerRef, droppableProps = _a.droppableProps, placeholder = _a.placeholder;
        function renderItem(u) {
            return React.createElement(GrouppedUserItem, { key: u.id, userItem: u, groupId: groupItem.id });
        }
        return (React.createElement("div", __assign({ ref: innerRef, style: { flexGrow: 1 } }, droppableProps),
            React.createElement(List, { gap: 10, renderItem: renderItem, items: groupItem.userItems }),
            placeholder));
    }
    var title = isStub || edit ? (React.createElement(Input, { autoFocus: true, value: newGroupName, onChange: nameChangeHandler, onKeyDown: confirmHandler, style: { height: 30, fontSize: 12, fontWeight: 'bold' } })) : (React.createElement("h4", { style: { margin: 0, marginRight: 10, fontWeight: 'bold' } }, groupItem.title));
    return (React.createElement("div", { style: GROUP_LIST_ITEM_STYLE },
        React.createElement("div", { style: GROUP_HEADER_STYLE },
            React.createElement("div", { style: { display: 'flex' } }, title),
            React.createElement("div", { style: { marginLeft: 15, display: 'flex', alignItems: 'center', position: 'relative' } },
                React.createElement(MoreOptions, { show: showOptions, toggleHandler: toggleOptions, onOutClick: closeOptionsHandler, options: [
                        { title: L('Edit'), Icon: RiEdit2Line, action: editOnHandler },
                        { title: L('Delete'), color: Color.RED, Icon: RiCloseFill, action: removeHandler },
                    ] }))),
        React.createElement(Droppable, { isCombineEnabled: true, key: groupItem.id, droppableId: "".concat(ResourceType.GROUP, ":").concat(groupItem.id) }, renderDroppableItem)));
}
function UsersTab(_a) {
    var userItems = _a.userItems;
    var L = useLanguage().L;
    var user = useAuth().user;
    var _b = useFuseSearch(userItems, FUSE_CONFIG), resultSet = _b.resultSet, searchString = _b.searchString, searchChangeHandler = _b.searchChangeHandler;
    function buttonClickHandler() {
        Manager.renderModal(React.createElement(UserModal, null));
    }
    function renderClone(_a, snapshot, rubric) {
        var innerRef = _a.innerRef, draggableProps = _a.draggableProps, dragHandleProps = _a.dragHandleProps;
        var item = items[rubric.source.index];
        return (React.createElement("div", __assign({ ref: innerRef }, draggableProps, dragHandleProps, { style: __assign(__assign({}, USER_LIST_ITEM_STYLE), draggableProps.style) }),
            React.createElement(UserContent, { userItem: item })));
    }
    function renderDroppableList(_a, _b) {
        var innerRef = _a.innerRef, placeholder = _a.placeholder;
        var draggingFromThisWith = _b.draggingFromThisWith;
        function renderUserItem(item, index) {
            var shoudRenderClone = "".concat(ResourceType.USER, ":").concat(item.id) === draggingFromThisWith;
            return shoudRenderClone ? (React.createElement("div", { key: item.id, style: USER_LIST_ITEM_STYLE, className: "react-beatiful-dnd-copy" },
                React.createElement(UserContent, { userItem: item }))) : (React.createElement(UserItem, { key: item.id, userItem: item, index: index }));
        }
        return (React.createElement(List, { gap: 10, items: items, innerRef: innerRef, Footer: placeholder, renderItem: renderUserItem, style: { paddingRight: 15, paddingLeft: 15, paddingBottom: 15 } }));
    }
    var items = resultSet !== null && resultSet !== void 0 ? resultSet : userItems;
    return (React.createElement(React.Fragment, null,
        React.createElement(HeaderWithButton, { title: L('Users'), disabled: !(user === null || user === void 0 ? void 0 : user.classActions.userClassActions.canCreate), buttonTitle: L('Create User'), buttonClickHandler: buttonClickHandler }),
        React.createElement(BorderdContainer, null,
            React.createElement(SearchInput, { css: SEARCH_INPUT_STYLE, name: "users", placeholder: L('Search'), value: searchString, onChange: searchChangeHandler }),
            React.createElement(Droppable, { renderClone: renderClone, droppableId: "users", isDropDisabled: true, direction: "vertical", mode: "standard" }, renderDroppableList))));
}
function GroupsTab(_a) {
    var groupItems = _a.groupItems;
    var L = useLanguage().L;
    var _b = __read(useState(), 2), newGroupStub = _b[0], setNewGroupStub = _b[1];
    var _c = useFuseSearch(groupItems, FUSE_CONFIG), resultSet = _c.resultSet, searchString = _c.searchString, searchChangeHandler = _c.searchChangeHandler;
    function removeStub() {
        setNewGroupStub(undefined);
    }
    function buttonClickHandler() {
        setNewGroupStub({ title: '', id: 0, style: null, userItems: [], stub: { removeStub: removeStub } });
    }
    function renderGroupItem(item, index) {
        return React.createElement(GroupItem, { key: item.id, groupItem: item, index: index });
    }
    var items = newGroupStub ? __spreadArray([newGroupStub], __read(groupItems), false) : groupItems;
    var filteredItems = resultSet !== null && resultSet !== void 0 ? resultSet : items;
    return (React.createElement(React.Fragment, null,
        React.createElement(HeaderWithButton, { title: L('Groups'), buttonTitle: L('Create Group'), buttonClickHandler: buttonClickHandler }),
        React.createElement(BorderdContainer, null,
            React.createElement(SearchInput, { css: SEARCH_INPUT_STYLE, name: "groups", placeholder: L('Search'), value: searchString, onChange: searchChangeHandler }),
            React.createElement(List, { gap: 10, numColumns: 3, items: filteredItems, renderItem: renderGroupItem, style: { paddingRight: 15, paddingLeft: 15, paddingBottom: 15 } }))));
}
function UsersGroupsManager() {
    var _a, _b;
    var users = useUsers();
    var groups = useGroups();
    var actionsByUserId = useActionsByUserId();
    var L = useLanguage().L;
    var user = useAuth().user;
    var addUserToGroup = useUserGroupActions().addUserToGroup;
    var _c = getUserAndGroupItems((_a = users.data) !== null && _a !== void 0 ? _a : [], groups, (_b = actionsByUserId.data) !== null && _b !== void 0 ? _b : {}), userItems = _c.userItems, groupItems = _c.groupItems;
    function dragEndHandler(_a) {
        var draggableId = _a.draggableId, destination = _a.destination;
        if (destination) {
            var _b = __read(draggableId.split(':'), 2), userIdString = _b[1];
            var _c = __read(destination.droppableId.split(':'), 2), groupIdString = _c[1];
            var userId = parseInt(userIdString);
            var groupId = parseInt(groupIdString);
            addUserToGroup(userId, groupId);
        }
    }
    function buttonClickHandler() {
        Manager.renderModal(React.createElement(PermissionsModal, null));
    }
    var contentHeader = !!(user === null || user === void 0 ? void 0 : user.isSuperUser) && (React.createElement(FSButton, { "$type": "tertiary", title: L('Edit permissions'), onClick: buttonClickHandler, style: { flex: 'right' } }));
    var contentLeft = React.createElement(UsersTab, { userItems: userItems });
    var contentRight = React.createElement(GroupsTab, { groupItems: groupItems });
    return (React.createElement(DragDropContext, { onDragEnd: dragEndHandler },
        React.createElement(ManagerLayoutWithButton, { title: L('Users & Groups Management'), contentHeader: contentHeader, contentLeft: contentLeft, contentRight: contentRight })));
}
export default UsersGroupsManager;
